jQuery(document).ready(function ($) {

    jQuery('.scroll_to_section_buttons .btn_item a').on('click', function (e) {
        e.preventDefault();
        var target = this.getAttribute('href');
        jQuery('html, body').animate({
            scrollTop: jQuery(target).offset().top - 100
        }, 1000);
    });

    jQuery('.search_result .content_item').hide();
    jQuery('.search_result .content_item:first-child').show();
    jQuery('.search_result .search_result_tab .tab_item:first-child').addClass("active");
    jQuery('.search_result .search_result_tab .tab_item').click(function () {
        jQuery('.search_result .content_item').not(('#tab_item_' + jQuery(this).attr('tabindex'))).hide();
        jQuery('.search_result .search_result_tab .tab_item').not(this).removeClass("active");
        if (jQuery('#tab_item_' + jQuery(this).attr('tabindex')).is(":hidden")) {
            jQuery('#tab_item_' + jQuery(this).attr('tabindex')).show();
            jQuery(this).addClass("active");
        }
    });

    $('.search-form input[type="search"]').focus(function () {
        $(this).parent().addClass('focus_input');
    }).blur(function () {
        $(this).parent().removeClass('focus_input');
    });

    $('.search-form input[type="search"]').blur(function () {
        if ($(this).val() != '') {
            $(this).parent().addClass('input-has-value');
        } else {
            $(this).parent().removeClass('input-has-value');
        }
    });

    var searchInput = '.search-form input[type="search"]';
    if ($(searchInput).val() != '') {
        $(searchInput).parent().addClass('input-has-value');
    } else {
        $(searchInput).parent().removeClass('input-has-value');
    }

    $('.banner-search-form input[type="search"]').focus(function () {
        $(this).parent().parent().addClass('focus_input');
    }).blur(function () {
        $(this).parent().parent().removeClass('focus_input');
    });

    $('.banner-search-form input[type="search"]').blur(function () {
        if ($(this).val() != '') {
            $(this).parent().parent().addClass('input-has-value');
        } else {
            $(this).parent().parent().removeClass('input-has-value');
        }
    });

    var searchInputBanner = '.banner-search-form input[type="search"]';
    if ($(searchInputBanner).val() != '') {
        $(searchInputBanner).parent().parent().addClass('input-has-value');
    } else {
        $(searchInputBanner).parent().parent().removeClass('input-has-value');
    }

    if (!$('select').hasClass("default_select")) {
        $('select').selectric({
            openOnFocus: false,
            disableOnMobile: false,
            nativeOnMobile: false,
            arrowButtonMarkup: '<b class="button"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7 7L13 1" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></b>',
        });
    }
    setTimeout(() => {
        if ($(".selectric-input").length > 0) {
            $(".selectric-input").attr("id", "category_filter_selectric_input");
            $(".selectric-input").each(function () {
                if ($(this).parent().find(".hide_in_background").length > 0) {
                    $(this).parent().find(".hide_in_background").remove();
                }
            })
            $('<label for="category_filter_selectric_input" class="hide_in_background">Selected Category</label>').insertBefore(".selectric-input");
        }
    }, 500);
    $(document).ajaxComplete(function () {
        $('select').selectric('refresh');
        if ($(".selectric-input").length > 0) {
            $(".selectric-input").attr("id", "category_filter_selectric_input");
            $(".selectric-input").each(function () {
                if ($(this).parent().find(".hide_in_background").length > 0) {
                    $(this).parent().find(".hide_in_background").remove();
                }
            })
            $('<label for="category_filter_selectric_input" class="hide_in_background">Selected Category</label>').insertBefore(".selectric-input");
        }
    });
    $(document).on('gform_page_loaded', function (event, form_id, current_page) {
        $('select').selectric('refresh');
        if ($(".selectric-input").length > 0) {
            $(".selectric-input").attr("id", "category_filter_selectric_input");
            $(".selectric-input").each(function () {
                if ($(this).parent().find(".hide_in_background").length > 0) {
                    $(this).parent().find(".hide_in_background").remove();
                }
            })
            $('<label for="category_filter_selectric_input" class="hide_in_background">Selected Category</label>').insertBefore(".selectric-input");
        }
    });

    jQuery('.gform_footer .gform_button').addClass('btn big_btn btn_white btn_with_arrow');
    jQuery(document).on('gform_page_loaded', function (event, form_id, current_page) {
        jQuery('.gform_footer .gform_button').addClass('btn big_btn btn_white btn_with_arrow');
    });

    $(".navbar-toggler-open").click(function () {
        $(".site-header").addClass("menu_active");
        $("body").addClass("toggle_menu_active");
        if ($('body').hasClass("toggle_search_active")) {
            $(".site-header").removeClass("search_active");
            $("body").removeClass("toggle_search_active");
        }
    });

    $(".navbar-toggler-mobile").on("keypress", function (e) {
        if (e.keyCode == 13) {
            if ($("body").hasClass("toggle_menu_active")) {
                $(".site-header").removeClass("menu_active");
                $("body").removeClass("toggle_menu_active");
                $(".site-header").removeClass("menu_sub_active");
                $('#mega-menu-primary').removeClass("sub-menu--active");
                $("#mega-menu-primary > li.mega-menu-item-has-children > .mega-sub-menu").removeClass("sub-open");
                $('#mega-menu-primary').removeClass("sub-child-menu--active");
                $("#mega-menu-primary > li.mega-menu-item-has-children > .mega-sub-menu .menu > li.menu-item-has-children > .sub-menu").removeClass("sub-open");
                $("#mega-menu-primary > li.mega-menu-item-has-children.mega-menu-flyout .mega-sub-menu").removeClass("sub-open");
            } else {
                $(".site-header").addClass("menu_active");
                $("body").addClass("toggle_menu_active");
                if ($('body').hasClass("toggle_search_active")) {
                    $(".site-header").removeClass("search_active");
                    $("body").removeClass("toggle_search_active");
                }
            }
        }
    });

    $(".navbar-toggler-close").click(function () {
        $(".site-header").removeClass("menu_active");
        $("body").removeClass("toggle_menu_active");
        $(".site-header").removeClass("menu_sub_active");
        $('#mega-menu-primary').removeClass("sub-menu--active");
        $("#mega-menu-primary > li.mega-menu-item-has-children > .mega-sub-menu").removeClass("sub-open");
        $('#mega-menu-primary').removeClass("sub-child-menu--active");
        $("#mega-menu-primary > li.mega-menu-item-has-children > .mega-sub-menu .menu > li.menu-item-has-children > .sub-menu").removeClass("sub-open");
        $("#mega-menu-primary > li.mega-menu-item-has-children.mega-menu-flyout .mega-sub-menu").removeClass("sub-open");
    });

    $(".header_with_carousel, .header_with_carousel.hero_banner .hero_banner__inner *:not(button, a)").attr("tabindex", -1);

    $(".search-toggler-open").click(function () {
        $(".site-header").addClass("search_active");
        $("body").addClass("toggle_search_active");
        setTimeout(function () {
            jQuery(".header-search-form-inner-wrapper-outer input[type='search']").focus();
        }, 500);
        if ($('body').hasClass("toggle_menu_active")) {
            $(".site-header").removeClass("menu_active");
            $("body").removeClass("toggle_menu_active");
            $(".site-header").removeClass("menu_sub_active");
            $('#mega-menu-primary').removeClass("sub-menu--active");
            $("#mega-menu-primary > li.mega-menu-item-has-children > .mega-sub-menu").removeClass("sub-open");
            $('#mega-menu-primary').removeClass("sub-child-menu--active");
            $("#mega-menu-primary > li.mega-menu-item-has-children > .mega-sub-menu .menu > li.menu-item-has-children > .sub-menu").removeClass("sub-open");
            $("#mega-menu-primary > li.mega-menu-item-has-children.mega-menu-flyout .mega-sub-menu").removeClass("sub-open");
        }
    });

    $(".search-toggler-close").click(function () {
        $(".site-header").removeClass("search_active");
        $("body").removeClass("toggle_search_active");
    });

    $("#mega-menu-primary > li").each(function () {
        if ($(this).hasClass("mega-menu-item-has-children")) {
            $(this).find(" > ul").prepend('<li class="custom_parent_link"><a href="#"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="10" viewBox="0 0 17 10" fill="none"><path d="M15.5 5H1M1 5L5 9M1 5L5 1" stroke="white" stroke-width="1.42" stroke-linecap="round" stroke-linejoin="round"/></svg><span>Back</span></a></li>');
            $(this).find("ul.menu > li").each(function () {
                if ($(this).hasClass("menu-item-has-children")) {
                    $(this).find(" > ul").prepend('<li class="custom_parent_link"><a href="#"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="10" viewBox="0 0 17 10" fill="none"><path d="M15.5 5H1M1 5L5 9M1 5L5 1" stroke="white" stroke-width="1.42" stroke-linecap="round" stroke-linejoin="round"/></svg><span>Back</span></a></li>');
                }
            })
            $(this).find("ul.mega-sub-menu > li").each(function () {
                if ($(this).hasClass("mega-menu-item-has-children")) {
                    $(this).find(" > ul").prepend('<li class="custom_parent_link"><a href="#"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="10" viewBox="0 0 17 10" fill="none"><path d="M15.5 5H1M1 5L5 9M1 5L5 1" stroke="white" stroke-width="1.42" stroke-linecap="round" stroke-linejoin="round"/></svg><span>Back</span></a></li>');
                }
            })
        }
    });

    $(document).on("click", "#mega-menu-primary > li.mega-menu-item-has-children > a", function (e) {
        if (jQuery(window).width() < 1200) {
            e.preventDefault();
            $(".site-header").addClass("menu_sub_active");
            $('#mega-menu-primary').addClass("sub-menu--active");
            $(this).parent().find(">.mega-sub-menu").addClass("sub-open");
        }
    });

    $(document).on("click", "#mega-menu-primary > li.mega-menu-item-has-children > .mega-sub-menu > .custom_parent_link", function (e) {
        e.preventDefault();
        $(".site-header").removeClass("menu_sub_active");
        $('#mega-menu-primary').removeClass("sub-menu--active");
        $(this).parent().removeClass("sub-open");
    });

    $(document).on("click", "#mega-menu-primary > li.mega-menu-item-has-children > .mega-sub-menu.sub-open .menu > li.menu-item-has-children > a", function (e) {
        e.preventDefault();
        $(".site-header").addClass("menu_sub_active");
        $('#mega-menu-primary').addClass("sub-child-menu--active");
        $(this).parent().find(">.sub-menu").addClass("sub-open");
    });

    $(document).on("click", "#mega-menu-primary > li.mega-menu-item-has-children > .mega-sub-menu.sub-open .menu > li.menu-item-has-children > .sub-menu.sub-open > .custom_parent_link", function (e) {
        e.preventDefault();
        $(".site-header").removeClass("menu_sub_active");
        $('#mega-menu-primary').removeClass("sub-child-menu--active");
        $(this).parent().removeClass("sub-open");
    });

    $(document).on("click", "#mega-menu-primary > li.mega-menu-item-has-children.mega-menu-flyout > .mega-sub-menu.sub-open > li.mega-menu-item-has-children > a", function (e) {
        e.preventDefault();
        $(".site-header").addClass("menu_sub_active");
        $('#mega-menu-primary').addClass("sub-child-menu--active");
        $(this).parent().find(">.mega-sub-menu").addClass("sub-open");
    });

    $(document).on("click", "#mega-menu-primary > li.mega-menu-item-has-children.mega-menu-flyout > .mega-sub-menu.sub-open > li.mega-menu-item-has-children > .mega-sub-menu.sub-open > .custom_parent_link", function (e) {
        e.preventDefault();
        $(".site-header").removeClass("menu_sub_active");
        $('#mega-menu-primary').removeClass("sub-child-menu--active");
        $(this).parent().removeClass("sub-open");
    });

    $("#mega-menu-primary > li.mega-menu-item-has-children.mega-menu-flyout").each(function () {
        var menuTitle = jQuery(this).find(">a");
        var text = $(menuTitle).text();
        var link = $(menuTitle).attr('href');
        var textPrepend = $(menuTitle).parent().find(">.mega-sub-menu >li.custom_parent_link");
        $('<li class="mega-menu-item mobile_title"><a href="' + link + '">' + text + '</a></li>').insertAfter(textPrepend);
    });


    $("#mega-menu-primary > li.mega-menu-item-has-children.mega-menu-flyout > .mega-sub-menu > li.mega-menu-item-has-children").each(function () {
        var menuTitleSub = jQuery(this).find(">a");
        var textSub = $(menuTitleSub).text();
        var linkSub = $(menuTitleSub).attr('href');
        var textPrependSub = $(menuTitleSub).parent().find(">.mega-sub-menu >li.custom_parent_link");
        $('<li class="mega-menu-item mobile_title"><a href="' + linkSub + '">' + textSub + '</a></li>').insertAfter(textPrependSub);
    });


    $('.search_item_link:not(.external)').click(function () {
        let searchValue = $(this).attr('data-value');
        window.location.href = '/?s=' + searchValue;
    });

    if ($('.header_headline_text_and_image').hasClass("add_lpink_shape")) {
        $('.header_headline_text_and_image').parent().addClass("pink_shape_active");
    }

    $(".site_footer .right_list .column .footer_menu_list").css("display", "none");
    $(".site_footer .right_list .column .heading").on("click", function (e) {
        e.preventDefault();

        if ($(window).width() < 768) {
            if ($(this).next().is(":hidden")) {
                $(".site_footer .right_list .column .heading").removeClass("active");
                $(".site_footer .right_list .column .footer_menu_list").slideUp();
                $(this).addClass("active");
                $(this).next().slideDown();
            } else {
                $(this).removeClass("active");
                $(this).next().slideUp();
            }
        }
    });

    if (jQuery(".hero_banner__inner").length > 0 && jQuery(".hero_banner__inner > div").length > 1) {
        jQuery(".hero_banner").each(function (index) {
            let slide = jQuery(this).find('.hero_banner__inner__item');
            let slider = jQuery(this).find('.hero_banner__inner');
            if (jQuery(slide).length > 1) {
                jQuery(slider).slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    prevArrow: jQuery(this).find('.prev-arrow'),
                    nextArrow: jQuery(this).find('.next-arrow'),
                    speed: 700,
                    autoplay: true,
                    autoplaySpeed: 3000,
                    //fade: true,
                });
            }
        });
    };
    jQuery(".latest_news_sec").each(function (index) {
        let slide = jQuery(this).find('.item');
        let slider = jQuery(this).find('.news_list');
        if (jQuery(slide).length > 1) {
            jQuery(slider).slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: false,
                dots: true,
                prevArrow: jQuery(this).find('.prev-arrow'),
                nextArrow: jQuery(this).find('.next-arrow'),
                variableWidth: true,
            });
        }
    });


    jQuery(".testimonial_slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        fade: true,
        prevArrow: jQuery('.testimonial_prev_arrow'),
        nextArrow: jQuery('.testimonial_next_arrow'),
        responsive: [{
            breakpoint: 1441,
            settings: {
                arrows: false,
                autoplay: false, //true
                autoplaySpeed: 5000,
            }
        }]
    });


    $(".video_sec_popup_link").click(function () {
        setTimeout(function () {
            $('body').addClass('video_popup_open');
        });
    });

    jQuery(document).on('lity:close', function (event, instance) {
        setTimeout(function () {
            $('body').removeClass('video_popup_open');
        }, 500);
    });

    // jQuery(".areas_of_research__inner").each(function (index) {
    jQuery(document).on('click', ".areas_of_research__inner .item_inner", function () {
        jQuery('.areas_of_research__inner .item_inner').removeClass("active");
        jQuery(this).addClass("active");
        if (jQuery(this).hasClass("active")) {
            jQuery(this).find("a").attr("tabindex", 0);
        } else {
            jQuery(this).find("a").attr("tabindex", -1);
        }
    });
    jQuery(document).on('keypress', ".areas_of_research__inner .item_inner", function (e) {
        if (e.keyCode == 13) {
            jQuery('.areas_of_research__inner .item_inner').removeClass("active");
            jQuery(this).addClass("active");
            if (jQuery(this).hasClass("active")) {
                jQuery(this).find("a").attr("tabindex", 0);
            } else {
                jQuery(this).find("a").attr("tabindex", -1);
            }
        }
    });
    // });

    equalheight('.grid_with_pastel_colour_wash_text_icon_cta_sec .title_text');
    equalheight('.grid_with_pastel_colour_wash_text_icon_cta_sec .short_content');

    equalheight('.grid_with_pastel_colour_wash .title_text');
    equalheight('.grid_with_pastel_colour_wash .short_content');

    equalheight('.topic_grid_x_three_row .title_text');
    equalheight('.topic_grid_x_three_row .content');

    equalheight('.topic_grid_x_four_row .title_text');
    equalheight('.topic_grid_x_four_row .content');

    equalheight('.events_list_sec .event_item .event_title');


    $slick_prev = '<button class="slick-prev" aria-label="previous"><svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" fill="none"><rect width="46" height="46" rx="23" transform="matrix(-1 0 0 1 46 0)" fill="#16397E"/><path d="M26.1816 31.3635L17.818 22.9999L26.1816 14.6362" stroke="#D6E4F4" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
    $slick_next = '<button class="slick-next" aria-label="next"><svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" fill="none"><rect width="46" height="46" rx="23" fill="#16397E"/><path d="M19.8184 31.3635L28.182 22.9999L19.8184 14.6362" stroke="#D6E4F4" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';

    jQuery('.people_slider_view').slick({
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false, //true
        autoplaySpeed: 5500,
        infinite: true,
        arrows: true,
        prevArrow: $slick_prev,
        nextArrow: $slick_next,
        appendArrows: ".slick_custom_arrow .slick_arrow_inner",
        variableWidth: false,
        responsive: [{
            breakpoint: 1441,
            settings: {
                slidesToShow: 3,
            }
        }, {
            breakpoint: 991,
            settings: {
                slidesToShow: 3,
                dots: true,
                arrows: false,
                variableWidth: true,
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 3,
                dots: true,
                arrows: false,
                variableWidth: true,
            }
        }, {
            breakpoint: 575,
            settings: {
                slidesToShow: 1,
                dots: true,
                arrows: false,
                variableWidth: true,
            }
        }]
    });

    offsetLeft();

    //new

    $(".areas_of_research__inner__wrapper .item_inner .hover_link").on("click", function (e) {
        e.preventDefault();
        var $this = $(this);
        if (!$this.hasClass("active")) {
            $(".areas_of_research__inner__wrapper .item_inner .hover_link").addClass("active");
            $(".areas_of_research__inner__wrapper .item_inner .hover_link").removeClass("active");
        }
        $this.toggleClass("active");
    });

    jQuery(document).on("click", ".search_post_card_loadmore .btn", function () {
        var attrMax = jQuery(this).attr("data-max");
        var attrProgress = jQuery(this).attr("data-progress");
        attrMax = parseInt(attrMax);
        attrProgress = parseInt(attrProgress) + 1;
        if (attrMax >= attrProgress) {
            jQuery(".post_card_list__boxs .div_class_" + attrProgress).show();
            jQuery(this).attr("data-progress", attrProgress);
            if (attrMax == attrProgress) {
                jQuery(this).hide();
            }
        } else {
            jQuery(this).hide();
        }
    });

    jQuery(".mapExplore .mapfilterbar .clear").on("click", function () {
        jQuery("body").scrollTop(0);
    });

    $(document).on('click', '.mapExplore .mapfilterbar .clear', function (event) {
        event.preventDefault();
        var target = 'body';
        $('html, body').animate({
            scrollTop: $(target).offset().top - 50
        }, 1000);
    });

    areasSlider();

    heightHeader();

    var FormInterval = setInterval(function () {
        if (document.readyState == "complete") {
            clearInterval(FormInterval);
            jQuery(".selectric-wrapper").attr("tabindex", 0);
            jQuery(".gfield.autocomplete_given_name input").attr("autocomplete", "given-name");
            jQuery(".gfield.autocomplete_family_name input").attr("autocomplete", "family-name");
            jQuery(".gfield.autocomplete_email input").attr("autocomplete", "email");
            jQuery(".gfield.autocomplete_company input").attr("autocomplete", "organization");
            jQuery(".gfield.autocomplete_tel input").attr("autocomplete", "tel");
            jQuery(".gfield.autocomplete_message input").attr("autocomplete", "message");
            jQuery(".gfield.autocomplete_postal_code input").attr("autocomplete", "postal-code");
            jQuery(".selectric-wrapper").removeAttr("tabindex")
        }
    }, 500);

    jQuery(document).on("click", ".the_team_section .people_list_section .people_list .item", function () {
        if (jQuery(this).find(".floating_link").length > 0) {
            jQuery(this).find(".floating_link").click();
        }
    })

    jQuery(document).on("keypress", ".the_team_section .people_list_section .people_list .item", function (e) {
        if (e.keyCode == 13 && jQuery(this).find(".floating_link").length > 0) {
            jQuery(this).find(".floating_link").click();
        }
    })

    jQuery(document).on("click", ".events_list_sec__inner .paginations__inner .pagination .page-item .page-link", function (e) {
        e.preventDefault();
    })

    research_items_slick();

    jQuery(".accordion__inner__wrapper .item__inner__content__inner>ul>li .list_title").on("click", function () {
        if (jQuery(this).parent().find(">ul").is(":hidden")) {
            jQuery(this).parent().find(">ul").slideDown();
            jQuery(this).parent().addClass("active");
        } else {
            jQuery(this).parent().find(">ul").slideUp();
            jQuery(this).parent().removeClass("active");
        }
    })

    if (jQuery(".section_scroll_to_section_buttons.enable_sticky_animation").length > 0) {
        jQuery(".section_scroll_to_section_buttons.enable_sticky_animation").css("top", jQuery("header.site-header").outerHeight() + "px");
    }
});

window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
        jQuery('select').selectric({
            openOnFocus: false,
            disableOnMobile: false,
            nativeOnMobile: false
        });
    }
});

jQuery(document).on('gform_page_loaded', function (event, form_id, current_page) {
    jQuery(".selectric-wrapper").attr("tabindex", 0);
    jQuery(".gfield.autocomplete_given_name input").attr("autocomplete", "given-name");
    jQuery(".gfield.autocomplete_family_name input").attr("autocomplete", "family-name");
    jQuery(".gfield.autocomplete_email input").attr("autocomplete", "email");
    jQuery(".gfield.autocomplete_company input").attr("autocomplete", "organization");
    jQuery(".gfield.autocomplete_tel input").attr("autocomplete", "tel");
    jQuery(".gfield.autocomplete_message input").attr("autocomplete", "message");
    jQuery(".gfield.autocomplete_postal_code input").attr("autocomplete", "postal-code");
});

function heightHeader() {

    var height = jQuery("header").outerHeight();
    jQuery(".main-menu").css({
        "top": height,
        "height": "calc(100vh - " + height + "px)"
    });
    jQuery(".site-header #mega-menu-wrap-primary #mega-menu-primary>li.mega-menu-megamenu>ul.mega-sub-menu").css({
        "top": height,
        "height": "calc(100vh - " + height + "px)"
    });
    jQuery(".site-header #mega-menu-wrap-primary #mega-menu-primary>li.mega-menu-megamenu>ul.mega-sub-menu .menu>li.menu-item .sub-menu").css({
        "top": height,
        "height": "calc(100vh - " + height + "px)"
    });
    if (jQuery(".admin-bar").length > 0) {
        if (jQuery(window).width() > 782) {
            var height = parseInt(height) + parseInt(32);
        } else {
            var height = parseInt(height) + parseInt(46);
        }
        jQuery(".main-menu").css({
            "top": height,
            "height": "calc(100vh - " + height + "px)"
        });
        jQuery(".site-header #mega-menu-wrap-primary #mega-menu-primary>li.mega-menu-megamenu>ul.mega-sub-menu").css({
            "top": height,
            "height": "calc(100vh - " + height + "px)"
        });
        jQuery(".site-header #mega-menu-wrap-primary #mega-menu-primary>li.mega-menu-megamenu>ul.mega-sub-menu .menu>li.menu-item .sub-menu").css({
            "top": height,
            "height": "calc(100vh - " + height + "px)"
        });
    } else {
        var height = parseInt(0);
    }
}

function areasSlider() {
    if (jQuery(window).width() < 992) {
        if (!jQuery('.slider').hasClass("slick-initialized")) {
            jQuery('.slider').slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 2000,
                dots: true,
                arrows: false,
                responsive: [{
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        variableWidth: true,
                    }
                }],

            });
        }

        jQuery(".areas_of_research__inner__wrapper .item_inner:not(.active) .link_list a").attr("tabindex", -1);
    } else {
        if (jQuery('.slider').hasClass("slick-initialized")) {
            jQuery('.slider').slick("unslick");
            jQuery('.slider').removeAttr("style");
        }
    }
}

jQuery(window).on("resize", function () {
    if (jQuery(".testimonial_slider").length > 0 && jQuery(".testimonial_slider").hasClass("slick-initialized")) {
        setTimeout(function () {
            jQuery(".testimonial_slider").slick("refresh");
        }, 200);
    }

    equalheight('.grid_with_pastel_colour_wash_text_icon_cta_sec .title_text');
    equalheight('.grid_with_pastel_colour_wash_text_icon_cta_sec .short_content');

    equalheight('.grid_with_pastel_colour_wash .title_text');
    equalheight('.grid_with_pastel_colour_wash .short_content');

    equalheight('.topic_grid_x_three_row .title_text');
    equalheight('.topic_grid_x_three_row .content');

    equalheight('.topic_grid_x_four_row .title_text');
    equalheight('.topic_grid_x_four_row .content');

    equalheight('.events_list_sec .event_item .event_title');

    offsetLeft();

    areasSlider();

    heightHeader();

    if (jQuery(window).width() < 768) {
        jQuery(".site_footer .right_list .column .footer_menu_list").css("display", "none");
    }

    research_items_slick();

    if (jQuery(".section_scroll_to_section_buttons.enable_sticky_animation").length > 0) {
        jQuery(".section_scroll_to_section_buttons.enable_sticky_animation").css("top", jQuery("header.site-header").outerHeight() + "px");
    }
});

equalheight = function (container) {

    var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = new Array(),
        $el,
        topPosition = 0;
    jQuery(container).each(function () {

        $el = jQuery(this);
        jQuery($el).height('auto')
        topPostion = $el.position().top;

        if (currentRowStart != topPostion) {
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                rowDivs[currentDiv].height(currentTallest);
            }
            rowDivs.length = 0; // empty the array
            currentRowStart = topPostion;
            currentTallest = $el.height();
            rowDivs.push($el);
        } else {
            rowDivs.push($el);
            currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
        }
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            rowDivs[currentDiv].height(currentTallest);
        }
    });
}

function offsetLeft() {
    if ((jQuery('.latest_news_sec__inner').length > 0)) {
        var applicationsoffset = jQuery('.latest_news_sec__inner').offset(),
            applicationswindWidth = jQuery(window).width();
        jQuery('.latest_news_sec__inner').css('width', (applicationswindWidth - applicationsoffset.left));
    }

    if (jQuery(window).width() < 992) {
        if ((jQuery('.people_slider_view').length > 0)) {
            var cateoffset = jQuery('.people_slider_view').offset(),
                windWidth = jQuery(window).width();
            jQuery('.people_slider_view').css('width', (windWidth - cateoffset.left));
        }
    }

    if (jQuery(window).width() < 992) {
        if ((jQuery('.areas_of_research__inner__wrapper').length > 0)) {
            var cateoffset = jQuery('.areas_of_research__inner__wrapper').offset(),
                windWidth = jQuery(window).width();
            jQuery('.areas_of_research__inner__wrapper').css('width', (windWidth - cateoffset.left));
        }
    }

}

function research_items_slick() {
    if (jQuery('.search_bar_inner .inner_sec .search_bar_sec_popular_search_inner .popular_search_list_inner').length > 0) {
        if (jQuery(window).width() < 768) {
            if (!jQuery(".search_bar_inner .inner_sec .search_bar_sec_popular_search_inner .popular_search_list_inner").hasClass("slick-initialized")) {
                jQuery('.search_bar_inner .inner_sec .search_bar_sec_popular_search_inner .popular_search_list_inner').slick({
                    dots: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: false, //true
                    autoplaySpeed: 5500,
                    infinite: false,
                    arrows: true,
                    prevArrow: jQuery(".search_bar_inner .inner_sec .search_bar_sec_popular_search_inner .slider_arrows .slide_prev"),
                    nextArrow: jQuery(".search_bar_inner .inner_sec .search_bar_sec_popular_search_inner .slider_arrows .slide_next"),
                    variableWidth: true,
                });
            }
        } else {
            if (jQuery(".search_bar_inner .inner_sec .search_bar_sec_popular_search_inner .popular_search_list_inner").hasClass("slick-initialized")) {
                jQuery(".search_bar_inner .inner_sec .search_bar_sec_popular_search_inner .popular_search_list_inner").slick("unslick");
            }
        }
    }
}